import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import myLogo from "../../../images/logo.svg";
import "./Header.css";

const Header = () => {
    return (
        <div style={{ marginBottom: "70px" }}>
            <Navbar
                expand="lg"
                className="nav-color"
                variant="dark"
                fixed="top"
            >
                <Container>
                    <Navbar.Brand as={Link} to="/home" className="text-danger">
                        <img
                            alt="my_logo"
                            src={myLogo}
                            height="50"
                            className="d-inline-block align-top rounded-3 bg-primary"
                        />
                        <span className="fs-2 fw-bold"> Naimur Rahman</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link as={Link} to="/aboutme">
                                About Me
                            </Nav.Link>
                            {/* <Nav.Link as={Link} to="/projects">
                                Projects
                            </Nav.Link> */}

                            <Nav.Link as={Link} to="/blogs">
                                Blogs
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;
